import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as ChartIcon } from 'Assets/svg/chart.svg';
import { ReactComponent as BarChartIcon } from 'Assets/svg/bar-chart.svg';
import * as CONSTANTS from 'Utils/constants';

const EmptyState = props => {
  const { chart, title = 'No purchase data available' } = props;
  return (
    <div className="empty-state-wrapper">
      {chart === 'bar' ? <BarChartIcon /> : <ChartIcon />}
      <div className="title">{title}</div>
      <div className="message">Begin your first contact purchase</div>
      <Link to={CONSTANTS.PAGE_PATH_MAP.CONTACT_SEARCH}>
        Go to Contact Search
      </Link>
    </div>
  );
};

export default EmptyState;
